<template>
  <div class="workBench-backlogTab">
   <!-- 待办事项 -->
   <div @click="toPath2('/messageNotification')" class="backlogTab-more">{{"更多>>"}}</div>
   <el-tabs
        v-loading = "itemLoading" v-model="activeName"  @tab-click="tabClick">
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
       label="待办事项" name="1">
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in tabData"  @click="clickViewFn(item.id,item.url,'','',1,item)">
            <p class="tab-item-p1 mb15"><span class="mr15">{{item.title}}</span></p>
            <!-- <p class="tab-item-p2 mb15"><span class="mr15">{{item.content}}</span></p> -->
            <p class="tab-item-p2 mb15"><span class="mr5 cz-tag">{{item.productLine}}</span><img class="mr5" src="../../../assets/images/icon_time.svg" alt=""><span>{{item.createTime|time}}</span></p>
          </div>
        </div>

        <emptyTab v-if="tabData&&tabData.length==0"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
       label="已办事项" name="2">
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in tabData"  @click="clickViewFn(item.id,item.url,'','',2,item)">
            <p class="tab-item-p1 mb15"><span class="mr15">{{item.title}}</span></p>
            <!-- <p class="tab-item-p2 mb15"><span class="mr15">{{item.content}}</span></p> -->
            <p class="tab-item-p2 mb15"><span class="mr5 cz-tag">{{item.productLine}}</span><img class="mr5" src="../../../assets/images/icon_time.svg" alt=""><span>{{item.createTime|time}}</span></p>
          </div>
        </div>
        <emptyTab v-if="tabData&&tabData.length==0"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane

        element-loading-text = "加载中..."
        element-loading-spinner = "el-icon-loading"
       label="消息通知" name="3">
        <div class="tab-list">
          <div class="tab-item" :key="idx" v-for="(item,idx) in tabData" @click.stop.prevent="clickViewFn(item.id,item.content,item.createTime,item.title,3,item)">
            <p class="tab-item-p1 mb15"><img v-if="item.isRead==0" src="../../../assets/images/noRead@1x.svg"><img v-if="item.isRead!=0" src="../../../assets/images/isRead@1x.svg"><span class="mr15">{{item.title}}</span></p>
            <!-- <p class="tab-item-p2 mb15"><span class="mr15">{{item.content}}</span></p> -->
            <p class="tab-item-p2 mb15"><span class="mr5 cz-tag">{{item.productLine}}</span><img class="mr5" src="../../../assets/images/icon_time.svg" alt=""><span>{{item.createTime|time}}</span></p>
          </div>
        </div>
        <emptyTab v-if="tabData&&tabData.length==0"></emptyTab>
        <el-pagination
          class="itemTab-page"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          prev-text="上一页"
          next-text="下一页"
          :page-size="4"
          layout="prev, next"
          :total="currentTotal">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      custom-class="realEstate"
      title="提示"
      :visible.sync="centerDialogVisible">
      <p>您即将进入地产系统，为确保功能正常使用，请使用IE10及以上版本浏览器，并设置兼容性</p>
      <!--<p><a href="javascript:;" @click="ieDown">IE10兼容性设置方法.docx</a></p>-->
      <p><a href="https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx">IE10兼容性设置方法.docx</a></p>
      <span slot="footer" class="dialog-footer clearfix">
        <el-checkbox v-model="noMorePrompts">今天不再提示</el-checkbox>
        <el-button type="primary" @click="centerDialogFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tag from './tag.vue'
import classTag from './classTag.vue'
import emptyTab from './emptyTab.vue'
export default {
  props: [],
  components: {
    'tag' : tag,
    'classTag' : classTag,
    'emptyTab' : emptyTab
  },
  data () {
    return {

      itemLoading: false,
      activeName: '1',
      currentPage: 1,
      currentTotal: 12,
      tabData: [],
      centerDialogVisible:false,
      noMorePrompts:false,
      messageId:'',
      messageUrl:'',
      messageTime:'',
      messageTitle:'',
      messageType:'',
      messageInfo:'',
      messageContent:''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {

    toPath (url) {
      window.open(url, '_blank')
    },
    toPath2(url,params={}){
      let routeData = this.$router.resolve({
        path: url,
        query:params
      });
      window.open(routeData.href, '_blank');
    },
    setList(data,cb){
      // data=res.data
      this.itemLoading = false
      // 待办
      if(this.activeName =='1'||this.activeName =='2'){

          this.tabData = data.queryTodoResponse.list
          this.currentTotal =this.activeName =='1'?Number(data.toDoNumber):Number(data.alreadyDoNumber)
        // if (data.queryTodoResponse.list.length < 4) {
        //   this.tabData = data.queryTodoResponse.list
        //   this.currentTotal = (this.currentPage - 1) * 4 + data.queryTodoResponse.list.length
        //   // console.info(this.currentTotal,this.currentPage)
        // } else if(data.queryTodoResponse.list&&data.queryTodoResponse.list.length==0){
        //   // this.tabData = data.queryTodoResponse.list
        //   cb && cb()
        //   this.currentTotal = (this.currentPage - 1) * 4 + (data.queryTodoResponse.list.length||0)
        //   // console.info(this.currentTotal,this.currentPage)
        // }else {
        //   this.tabData = data.queryTodoResponse.list
        //   this.currentTotal = this.currentPage * 4 + 1
        // }
      }else{

          this.tabData = data.queryNotifyResponse.list
          this.currentTotal = Number(data.queryNotifyResponse.pageInfo.totalRecords)
        // 消息
        // if (data.queryNotifyResponse.list.length < 4) {
        //   this.tabData = data.queryNotifyResponse.list
        //   this.currentTotal = (this.currentPage - 1) * 4 + data.queryNotifyResponse.list.length
        //   // console.info(this.currentTotal,this.currentPage)
        // } else if(data.queryNotifyResponse.list&&data.queryNotifyResponse.list.length==0){
        //   // this.tabData = data.queryNotifyResponse.list
        //   cb && cb()
        //   this.currentTotal = (this.currentPage - 1) * 4 + (data.queryNotifyResponse.list.length||0)
        //   // console.info(this.currentTotal,this.currentPage)
        // }else {
        //   this.tabData = data.queryNotifyResponse.list
        //   this.currentTotal = this.currentPage * 4 + 1
        // }
      }
    },
    // 获取列表
    getList(cb){
      this.itemLoading = true
      if (this.activeName =='1') {
        // 待办事项
        this.findTodoInfo('0',()=>{
          cb&&cb()
        })
      } else if (this.activeName =='2') {
        // 已办事项
        this.findTodoInfo('1',()=>{
          cb&&cb()
        })
      } else if (this.activeName =='3') {
        // 消息通知
        this.findNoticeInfo(()=>{
          cb&&cb()
        })
      }
    },
    tabClick(val) {
      console.info(val)
      this.currentPage = 1
      this.currentTotal = 12
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage=val

      // this.getList(()=>{
      //   this.currentPage=val-1
      // })
      this.getList()
    },
    // POST /message/findTodoInfo查询待办事项isFinish 0 待办事项，1已办事项
    findTodoInfo (isFinish, cb) {
      this.itemLoading = true
      this.$axios
        .post('/onelink.mdata.main.api/message/findTodoInfo', {
          pageNo: this.currentPage,
          pageSize: 4,
          isFinish
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          // this.itemLoading = false
        });
    },
    // POST /message/findNoticeInfo查询消息通知
    findNoticeInfo (cb) {
      this.itemLoading = true
      this.$axios
        .post('/onelink.mdata.main.api/message/findNoticeInfo', {
          pageNo: this.currentPage,
          pageSize: 4
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
          // this.itemLoading = false
        });
    },
    clickViewFn(id,messageUrl,time,title,messageType,message){
      this.messageId = id,
        this.messageUrl = messageUrl;
      this.messageTime = time;
      this.messageTitle = title;
      this.messageType = messageType;
      this.messageInfo = message;
      if(message.productLine == "-" && this.getCookie('TODAY_NO_MORE_REMINDER') == 0){
        this.centerDialogVisible = true;
      }else{
        this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
          this.messageType,this.messageInfo)
      }
    },
    viewMessage(id,messageUrl,time,title,messageType,message){
      if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(this.messageType == 3){
          this.$axios.post('/onelink.mdata.main.api/message/markRead', {
            id:id
          }).then((res) => {
            this.data = res.data;
            if(messageUrl.slice(0,4) == 'http'){
              window.location.href = messageUrl;
            }else{
              this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
            }
          }).catch((err) => {
            console.log(err)
          })
        }else{
          if(messageUrl.slice(0,4) == 'http'){
              if(message.productLine == '供应商管理'){
                window.location.href = messageUrl+message.isFinish+"&Id="+message.id;
              }else{
                if(messageUrl.indexOf("ep.fosunproperty.com")>0){
                  // let userSsoToken = Cookies.get("user_sso_token");
                  // let landedUrl = messageUrl+"&token="+userSsoToken;
                  // window.location.href= landedUrl;
                  let foSunUrl = "https://ep.fosunproperty.com:8888/";
                  let userSsoToken = Cookies.get("user_sso_token");
                  messageUrl = messageUrl.split("?")[1];
                  let guid = this.getUrlKey('guid',"?"+messageUrl)
                  let landedUrl = foSunUrl  +"Interface/YiLianAction.aspx?action=centerPage&token="+userSsoToken+"&pguid="+ this.refSysId+"&language=zh_CN";
                  window.location.href= landedUrl;
                }else if(messageUrl.indexOf("?")>0){
                  window.location.href = messageUrl+"&todoId="+message.id;
                }else{
                  window.location.href = messageUrl+"?todoId="+message.id;
                }
              }
            }else{
              this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
            }
        }
      }
    },
    search(productLineType,messageType){
      this.$emit('changeProductline', productLineType);
    },
    mobileClick(id,messageUrl,time,title,messageType,messageUrl2,pro){
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
        if(this.getToken('examineStatus') == '200'){
          this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
        }else if(this.getToken('examineStatus') == '300'){
          this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
        }
        else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
          this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
        }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
            dangerouslyUseHTMLString: true,
            center: true,
            showClose:false,
            customClass:'mobileText'
          })
//          if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//            this.$alert('<p>请登录pc端完善企业信息</p>', '', {
//              dangerouslyUseHTMLString: true,
//              center: true,
//              showClose:false,
//              customClass:'mobileText'
//            })
//          } else {
//
//            this.$alert('您的企业信息不完整，无法进入项目。请立即完善企业信息', '', {
//              confirmButtonText: '立即完善企业信息',
//              center: true,
//              showClose:false,
//                customClass:'mobileText',
//              callback: action => {
//                this.$router.push({path:'/inforPerfection'});
//              }
//            });
//          }

        }
        else{
//          if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          if(messageType==2){
            this.viewMessage(id,messageUrl,time,title,messageType,pro)
          }else{
            this.viewMessage(id,messageUrl2,'','',messageType,pro)
          }
          //          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
          //            dangerouslyUseHTMLString: true,
          //            center: true,
          //            showClose:false,
          //            customClass:'mobileText'
          //          })
//          } else {
//            console.log('ip')
//            return;
//          }
        }
      }else{
        console.log('ip')
        return;
      }

    },
    ieDown(){
      let url = "https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx"
      this.$axios.get('/onelink.mdata.main.api/upload/getDownloadURL?fioleKey='+url, {
      }).then((res) => {
        window.location.href=res.data;
      }).catch((err) => {
          console.log(err)
      })
    },
    centerDialogFn(){
      this.centerDialogVisible = false;
      if(this.noMorePrompts){
        this.$axios.post('/onelink.mdata.main.api/web/todayNoMoreRemainder', {
        }).then((res) => {
          if(res.data.code == 0){
            if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
              this.mobileClick(this.messageId,this.messageContent,this.messageTime, this.messageTitle,
                this.messageType,this.messageUrl,this.messageInfo)
            }else{
              this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
                this.messageType,this.messageInfo)
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      }else{
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          this.mobileClick(this.messageId,this.messageContent,this.messageTime, this.messageTitle,
            this.messageType,this.messageUrl,this.messageInfo)
        }else{
          this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
            this.messageType,this.messageInfo)
        }
      }

    }

  }
}
</script>
<style>
.workBench-backlogTab{
  position: relative;
}
.workBench-backlogTab .backlogTab-more{
  height: 40px;
  line-height: 40px;
  position: absolute;
  right: 15px;
  top:15px;
  z-index: 2;
  font-size: 12px;
  color:#2E8AF1;
}
.workBench-backlogTab .backlogTab-more:hover{
  cursor: pointer;
}
.workBench-backlogTab .mr15{
  margin-right: 15px;
}
.workBench-backlogTab .mb15{
  margin-bottom: 15px;
}
.workBench-backlogTab .mr5{
  margin-right: 5px;
}
.workBench-backlogTab{
  background:#fff;
  border-radius: 5px;
  border-radius: 5px;
  padding:15px
}
.workBench-backlogTab .tab-list{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.workBench-backlogTab .tab-list:hover{
  cursor: pointer;
}
.workBench-backlogTab .tab-item{
  width: 49.5%;
  background: #fff;
  padding: 15px 15px 0;
  border-right: 1px solid #E6E8EB;
}
.workBench-backlogTab .tab-item:nth-child(2n){
  border-right: 0;
}
.workBench-backlogTab .tab-item:nth-child(1){
  border-bottom: 1px solid #E6E8EB;
}
.workBench-backlogTab .tab-item:nth-child(2){
  border-bottom: 1px solid #E6E8EB;
}
.workBench-backlogTab .tab-item-p1{
  /*

    display: -webkit-box;               // 将对象作为弹性伸缩盒子模型显示 。
    text-overflow: ellipsis;            // 可以用来多行文本的情况下，用省略号“...”隐藏超出范围的文本 。
    -webkit-box-orient: vertical;       // 设置或检索伸缩盒对象的子元素的排列方式 。
    -webkit-line-clamp: 2;              // 限制在一个块元素显示的文本的行数。
  */

  height:36px;
  font-size: 12px;
  color: #303133;
  line-height: 18px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.workBench-backlogTab .tab-item-p1 img{
  margin-right: 10px;
}
.workBench-backlogTab .tab-item-p2{
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}
.workBench-backlogTab .tab-item-p3{
  font-size: 12px;
  color: #303133;
  line-height: 18px;
}
.workBench-backlogTab .tab-item-p2 img{
  vertical-align: middle;
}
.workBench-backlogTab .backlogTab-page {
  text-align: right;
}
.workBench-backlogTab .backlogTab-page .btn-prev,.workBench-backlogTab .backlogTab-page .btn-next{
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  color:#606266;
  font-size: 12px;
  font-weight: normal;
  line-height: 30px;
  height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  border-radius: 4px;
}
.workBench-backlogTab .backlogTab-page button:hover {
    color: #2E8AF1;
}
.workBench-backlogTab .backlogTab-page button:disabled {
    color: #C0C4CC;
    background-color: #FFF;
    cursor: not-allowed;
}
.workBench-backlogTab .cz-tag{

  position: relative;
  display: inline-block;
  background: #F0F2F5;;
  padding: 3px 10px;
  font-size: 12px;
  color: #909399;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
  border-radius: 3px;
}
.workBench-backlogTab .itemTab-page {
  text-align: right;
}
.workBench-backlogTab .itemTab-page .btn-prev,.workBench-backlogTab .itemTab-page .btn-next{
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  color:#606266;
  font-size: 12px;
  font-weight: normal;
  line-height: 30px;
  height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  border-radius: 4px;
}
.workBench-backlogTab .itemTab-page button:hover {
    color: #2E8AF1;
}
.workBench-backlogTab .itemTab-page button:disabled {
    color: #C0C4CC;
    background-color: #FFF;
    cursor: not-allowed;
}

.workBench-backlogTab .el-tabs__item:hover {
    color: #2E8AF1;
    cursor: pointer;
}

.workBench-backlogTab .el-tabs__item.is-active {
    color: #2E8AF1;
  font-weight: bold;
}
.workBench-backlogTab .el-tabs__active-bar {
    background-color: #2E8AF1;
}
</style>


// WEBPACK FOOTER //
// src/pages/workBench/components/backlogTab.vue